import React from "react";
import { Field } from "redux-form";
import {
  Table,
  TableHeader,
  TableHeaderColumn,
  TableBody,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import { Box } from "rebass";
import RaisedButton from "material-ui/RaisedButton";
import { cyan500 } from "material-ui/styles/colors";
import IconButton from "material-ui/IconButton";
import { TextField } from "redux-form-material-ui";
import { styles } from "./styles";
import { IconAdd, IconDelete } from "../components/mui/icon";
import { checkNumber } from "../components";

const required = value => (value || value === 0 ? undefined : "Required");

const number = value =>
  value && isNaN(Number(value)) ? "Must be a number" : undefined;

export const renderTermList = ({
  fields,
  meta: { error, submitFailed },
  translate
}) => (
  <div>
    <Box w={[1]} pb={[1]} pt={[2]}>
      <RaisedButton
        primary
        label="Terms"
        labelPosition="before"
        onClick={() => fields.push({ term: 0, interest: 0, fee: 0 })}
        icon={<IconAdd />}
      />
    </Box>
    <Table selectable={false}>
      <TableHeader
        displaySelectAll={false}
        adjustForCheckbox={false}
        style={{ backgroundColor: cyan500 }}
      >
        <TableRow>
          <TableHeaderColumn style={styles.headerTable}>
            {translate("resources.payments.field.terms.term")}
          </TableHeaderColumn>
          <TableHeaderColumn style={styles.headerTable}>
            {translate("resources.payments.field.terms.interest")}
          </TableHeaderColumn>
          <TableHeaderColumn style={styles.headerTable}>
            {translate("resources.payments.field.terms.fee")}
          </TableHeaderColumn>
          <TableHeaderColumn style={{ width: 40 }} />
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        {fields.map(renderTermFields)}
      </TableBody>
    </Table>
  </div>
);

const renderTermFields = (items, index, fields) => (
  <TableRow key={index}>
    <TableRowColumn>
      <Field
        key={index}
        label=""
        type="number"
        name={`${items}.term`}
        component={TextField}
        placeholder="Term"
        validate={[required, number]}
        parse={v => checkNumber(v)}
      />
    </TableRowColumn>
    <TableRowColumn>
      <Field
        label=""
        name={`${items}.interest`}
        type={"number"}
        component={TextField}
        placeholder="Interest %"
        validate={[required, number]}
        parse={v => checkNumber(v)}
      />
    </TableRowColumn>
    <TableRowColumn>
      <Field
        label=""
        type={"number"}
        name={`${items}.fee`}
        component={TextField}
        placeholder="Fee %"
        validate={[required, number]}
        parse={v => checkNumber(v)}
      />
    </TableRowColumn>
    <TableRowColumn style={{ width: 40 }}>
      <IconButton
        iconStyle={{ color: cyan500 }}
        onClick={() => fields.remove(index)}
      >
        <IconDelete />
      </IconButton>
    </TableRowColumn>
  </TableRow>
);



// WEBPACK FOOTER //
// ./src/payment/TermFields.js